import './button.css';
import * as cn from 'classnames';

export const Button = ({ icon, size = 'normal', textAlign = 'left', width = 'normal', color = 'normal', disabled = false, onClick, children }) => {
  return (
    <div
      className={cn('button-container', size, textAlign, width, color, disabled ? 'disabled' : '', icon && !children ? 'icon-only' : '')}
      onClick={(e) => (!disabled ? onClick(e) : null)}
    >
      {children && <div className="button-label">{children}</div>}
      {/* {icon && <div className="button-icon-container">{icon}</div>} */}
      {icon}
    </div>
  );
};
